import {
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
} from "@fluentui/react-components";
import { MoreVerticalRegular } from "@fluentui/react-icons";
import { ErrorBadgeIcon, RefreshIcon } from "@fluentui/react-icons-mdl2";
import { OfferAzureSearch } from "library/types/types_old";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom"; // Updated import
import { useStornoDialog } from "../../../hooks/useStornoDialog";

type Props = {
  offer?: OfferAzureSearch;
};

export const ContextButton = ({ offer }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate(); // Updated hook
  const { openStornoDialog } = useStornoDialog();

  if (!offer) return null;

  const onClickInvalidateOffer = () => {
    openStornoDialog(offer.OfferId);
  };

  const onClickRepeatOffer = () => {
    navigate("/offer?repeat=" + offer.OfferId); // Updated navigation
  };
  const items = [
    {
      key: "invalidateOffer",
      text: t("ila.storno.title"), // Updated to use our new translation
      iconProps: <ErrorBadgeIcon />,
      disabled: offer.Status + "" !== "1",
      onClick: onClickInvalidateOffer,
    },
    {
      key: "repeatOffer",
      text: t("sag.offers.contextMenu.repeat"),
      iconProps: <RefreshIcon />,
      disabled: false,
      onClick: onClickRepeatOffer,
    },
  ];
  return (
    <>
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <MenuButton appearance="transparent" icon={<MoreVerticalRegular />} />
        </MenuTrigger>
        <MenuPopover>
          <MenuList>
            {items.map((item) => (
              <MenuItem
                key={item.key}
                onClick={item.onClick}
                disabled={item.disabled}
              >
                <div style={{ display: "flex" }}>
                  <div style={{ width: "20px" }}>{item.iconProps}</div>
                  <div>{item.text}</div>
                </div>
              </MenuItem>
            ))}
          </MenuList>
        </MenuPopover>
      </Menu>
    </>
  );
};
